import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  container: {
    'page-break-after': 'always',
    borderTop: '1px solid #636363',
    bottom: -10,
    width: 'calc(100% - 50px)',
    paddingTop: 15,
    fontSize: 8,
    position: 'absolute',
  },
}));

const GenerateReportsFooter = ({ todayDate, pageNum, pageTotal }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={classes.container}
    >
      <div className={classes.date}>{todayDate}</div>
      <div className={classes.page}>{`Page ${pageNum}/${pageTotal} `}</div>
    </Grid>
  );
};

GenerateReportsFooter.propTypes = {
  todayDate: PropTypes.string.isRequired,
  pageNum: PropTypes.number.isRequired,
  pageTotal: PropTypes.number.isRequired,
};

export default GenerateReportsFooter;
